/* Edge: use its existing variant-change event and server-rendered metafield. */
(() => {
  if (customElements.get('maugo-made-to-order')) return;

  customElements.define('maugo-made-to-order', class extends HTMLElement {
    connectedCallback() {
      this.connectionToken = {};
      const token = this.connectionToken;
      customElements.whenDefined('product-info').then(() => {
        if (!this.isConnected || this.connectionToken !== token) return;
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data } = {}) => {
          if (!data) return;
          const productInfo = this.closest('product-info');
          const sectionId = productInfo?.dataset.originalSection || productInfo?.dataset.section;
          if (!sectionId || String(data.sectionId) !== sectionId) return;

          if (!data.variant) {
            this.replaceChildren();
            return;
          }
          const source = data.html?.querySelector(
            `maugo-made-to-order[data-product-id="${this.dataset.productId}"]`
          );
          // HTML comes from Edge's existing Shopify section response.
          // Copy only the notice; never replace the live status container.
          this.innerHTML = source?.innerHTML || '';
        });
      });
    }

    disconnectedCallback() {
      this.connectionToken = null;
      this.unsubscribe?.();
      this.unsubscribe = null;
    }
  });
})();
